"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Style = void 0;
const style_module_scss_1 = __importDefault(require("./style.module.scss"));
const Style = (styleOrArray, styles, prefix = '_modal-') => {
    styles = styles !== null && styles !== void 0 ? styles : style_module_scss_1.default;
    if (Array.isArray(styleOrArray)) {
        return styleOrArray.map(() => (0, exports.Style)(styleOrArray, prefix)).join(' ');
    }
    else {
        return `${styles[styleOrArray]} ${prefix}${styleOrArray}`;
    }
};
exports.Style = Style;
